interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}
export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

const HomepageBannerCTAValues = {
    control: 'search',
    base: 'city_browse',
};

export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'banner_cta_opens_search_screen',
    paramName: 'banner_cta_destination',
    values: HomepageBannerCTAValues,
};

const HomepageImageCategoryBrowseValues = {
    base: 'base',
    varaint1: 'browse',
    variant2: 'filter',
};

export const HomepageImageCategoryBrowse: Experiment<
    typeof HomepageImageCategoryBrowseValues
> = {
    name: 'homepage_image_category_browse',
    paramName: 'category_browse_cta',
    values: HomepageImageCategoryBrowseValues,
};

export enum SearchMapSmokeTestExperimentValues {
    control = 'control',
    variantA = 'variantA',
}

export const SearchMapSmokeTestExperiment: Experiment<
    typeof SearchMapSmokeTestExperimentValues
> = {
    name: 'search_view_map_smoke_test',
    paramName: 'smoke_map_type',
    values: SearchMapSmokeTestExperimentValues,
};

/**
 * Leave the names of the enums/configs/etc static to keep imports from
 * needing to change as we iterate.
 *
 * Update the values to represent the new focus/paramname/goal of the test.
 * At the moment these correlate to the card map exported from DiscoverEventCard.
 */
export enum SearchCardFullClickExperimentValues {
    control = 'control',
    fullClick = 'fullClick',
}

export const SearchCardFullClickExperiment: Experiment<
    typeof SearchCardFullClickExperimentValues
> = {
    name: 'search_event_card_full_click_client',
    paramName: 'search_card_type',
    values: SearchCardFullClickExperimentValues,
};

export const SearchBoxAndLocationPillValues = {
    control: 'appears',
    base: 'does_not_appear',
};

export const SearchBoxAndLocationPillExperiment: Experiment<
    typeof SearchBoxAndLocationPillValues
> = {
    name: 'search_box_and_location_pill',
    paramName: 'search_bar_and_location_pill',
    values: SearchBoxAndLocationPillValues,
};

export enum BrowseCardHierarchyExperimentValues {
    control = 'control',
    hierarchy = 'hierarchy',
}

export const BrowseCardHierarchyExperiment: Experiment<
    typeof BrowseCardHierarchyExperimentValues
> = {
    name: 'browse_card_1',
    paramName: 'browse_card_type',
    values: BrowseCardHierarchyExperimentValues,
};
